import { AxiosResponse } from 'axios';
import { apiV2 } from './http';
import {
  CreateBatchRequest,
  CreateBatchResponse,
  IssueManyNfseResponse,
  IssueNfseResponse,
  ListBatchResponse,
  ListNfseInput,
  ListNfseResponse,
  NfseBatchResponse,
  ValidateBatchRequest,
  ValidateBatchResponse,
} from './interfaces/nfse';

const BASE_PATH = 'nfse/batch';
const NFSE_PATH = 'nfse';

export function listBatches(): Promise<AxiosResponse<ListBatchResponse>> {
  return apiV2.get<ListBatchResponse>(`${BASE_PATH}/list`);
}

export function getBatch(
  id: number,
): Promise<AxiosResponse<NfseBatchResponse>> {
  return apiV2.get<NfseBatchResponse>(`${BASE_PATH}/${id}`);
}

export function validateBatch(
  payload: ValidateBatchRequest,
): Promise<AxiosResponse<ValidateBatchResponse>> {
  return apiV2.post<ValidateBatchResponse>(`${BASE_PATH}/validate`, payload);
}

export function createBatch(
  payload: CreateBatchRequest,
): Promise<AxiosResponse<CreateBatchResponse>> {
  return apiV2.post<CreateBatchResponse>(`${BASE_PATH}`, payload);
}

export function listNfse(
  params: ListNfseInput,
): Promise<AxiosResponse<ListNfseResponse>> {
  const queryParams = new URLSearchParams();

  if (params.startDateTime)
    queryParams.append('startDateTime', params.startDateTime);
  if (params.endDateTime) queryParams.append('endDateTime', params.endDateTime);
  if (params.status && params.status.length > 0) {
    queryParams.append('status', params.status.join(','));
  }
  if (params.referenceMonth)
    queryParams.append('referenceMonth', params.referenceMonth);
  if (params.taxCode) queryParams.append('taxCode', params.taxCode);
  if (params.nbsCode) queryParams.append('nbsCode', params.nbsCode);
  if (params.document) queryParams.append('document', params.document);
  if (params.accessKey) queryParams.append('accessKey', params.accessKey);
  if (params.limit !== undefined)
    queryParams.append('limit', params.limit.toString());
  if (params.offset !== undefined)
    queryParams.append('offset', params.offset.toString());

  const queryString = queryParams.toString();
  const url = queryString
    ? `${NFSE_PATH}/list?${queryString}`
    : `${NFSE_PATH}/list`;

  return apiV2.get<ListNfseResponse>(url);
}

export function issueNfse(
  orderId: number,
): Promise<AxiosResponse<IssueNfseResponse>> {
  return apiV2.post<IssueNfseResponse>(`${NFSE_PATH}/issue`, { orderId });
}

export function issueManyNfse(
  startDate: string,
  endDate: string,
  maxOrders: number,
): Promise<AxiosResponse<IssueManyNfseResponse>> {
  return apiV2.post<IssueManyNfseResponse>(`${NFSE_PATH}/issue-many`, {
    startDate,
    endDate,
    maxOrders,
  });
}

export function getDanfseNfse(accessKey: string): Promise<AxiosResponse<Blob>> {
  return apiV2.get<Blob>(`${NFSE_PATH}/danfse/${accessKey}`, {
    responseType: 'blob',
  });
}

export function getXmlNfse(accessKey: string): Promise<AxiosResponse<string>> {
  return apiV2.get<string>(`${NFSE_PATH}/xml/${accessKey}`, {
    responseType: 'text',
  });
}

export function sendEmailNfse(accessKey: string): Promise<AxiosResponse<void>> {
  return apiV2.post<void>(`${NFSE_PATH}/send-email/${accessKey}`);
}
